import { TypeCompiler } from '@sinclair/typebox/compiler';

import { ScheduleIncrementObject } from '../schema/schedule-increment-object.schema';

export const ScheduleIncrementObjectValidator = TypeCompiler.Compile(
  ScheduleIncrementObject,
);
